import { EditActionDefinition } from '@wix/editor-platform-host-integration-apis';
import { Actions } from '@wix/component-protocol/schema';
import {
  resolvePlatformActionsWithFactories,
  resolveHostActionsWithFactories,
} from '../utils';
import { PlatformContext, ContributedEditActionsDict } from '../types';
import { platformNativeActions } from './platformNativeActions';

function getResolvedEditActions<
  TActionDefinition extends EditActionDefinition = EditActionDefinition,
>(
  contributedActions: ContributedEditActionsDict,
  manifestActions: Actions,
  platformContext: PlatformContext,
): TActionDefinition[] {
  const resolvedPlatformNativeActions =
    resolvePlatformActionsWithFactories<TActionDefinition>(
      platformNativeActions,
      manifestActions,
      platformContext,
    );

  const resolvedHostActions =
    resolveHostActionsWithFactories<TActionDefinition>(
      contributedActions,
      manifestActions,
      platformContext,
    );

  return [...resolvedPlatformNativeActions, ...resolvedHostActions];
}

export { getResolvedEditActions };
